"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5509],{

/***/ 75176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ AnalyticsConstants; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_freeze_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43371);
/* harmony import */ var core_js_modules_es_object_freeze_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_freeze_js__WEBPACK_IMPORTED_MODULE_0__);

var AnalyticsConstants = Object.freeze({
  collapseText: 'Collapse Link',
  expandText: 'Expand Link',
  learnMoreText: 'Learn More',
  countrySelectorText: 'Open Country Selector Panel',
  openVideoText: 'Open Video',
  buttonPriceText: 'Open Price Panel',
  contentVideoOverlayText: 'Outside Panel',
  videoPlayText: 'Play',
  videoPauseText: 'Pause',
  videoMuteText: 'Sound: Off',
  videoUnmuteText: 'Sound: On',
  videoCloseCaptionsOnText: 'Caption: On',
  videoCloseCaptionsOffText: 'Caption: Off',
  videoFullscreenOnText: 'Full Screen: On',
  videoFullscreenOffText: 'Full Screen: Off',
  dropdownMenu: 'Dropdown Menu',
  rotationView: '360 View',
  facebook: 'Facebook',
  twitter: 'Twitter',
  openLiveChat: 'Open Live Chat',
  expandFaq: 'Expand FAQ',
  previousPage: 'Previous Page',
  nextPage: 'Next Page',
  promoRedeem: 'Redeem: ',
  calender: 'Calender'
});

/***/ }),

/***/ 48853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49376);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33227);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88361);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88674);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_5__);







var VideoPlayerFactory = /*#__PURE__*/function () {
  function VideoPlayerFactory(reactRef, video) {
    _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1___default()(this, VideoPlayerFactory);

    this.video = video;
    this.initSettings();
    this.videoRef = reactRef;
  }

  _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_2___default()(VideoPlayerFactory, [{
    key: "initSettings",
    value: function initSettings() {
      __webpack_require__(14060);

      this.settings = this.video.videoSettings; // If no settings then we use auto for quality and format.

      if (this.settings == null) {
        this.settings = {
          fields: {
            quality: 'auto',
            videoFormat: 'auto'
          }
        };
      }

      var hasSize = this.settings.fields.width != null || this.settings.fields.height != null; // Provide a default crop if sizes are provided.

      if (hasSize && this.settings.fields.crop == null) {
        this.settings.fields.crop = 'limit';
      }
    }
  }, {
    key: "getSettings",
    value: function getSettings() {
      return this.settings;
    }
  }, {
    key: "getVideo",
    value: function getVideo() {
      return this.video;
    }
  }, {
    key: "getVideoRef",
    value: function getVideoRef() {
      return this.videoRef;
    }
  }, {
    key: "create",
    value: function () {
      var _create = _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_3___default().mark(function _callee() {
        var transformation, videoPlayer;
        return _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_3___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                transformation = {
                  video_codec: this.settings.fields.videoFormat,
                  quality: this.settings.fields.quality
                };

                if (this.settings.fields.crop != null) {
                  transformation.crop = this.settings.fields.crop;
                }

                if (this.settings.fields.width != null) {
                  transformation.width = this.settings.fields.width;
                }

                if (this.settings.fields.height != null) {
                  transformation.height = this.settings.fields.height;
                }

                videoPlayer = {};
                _context.next = 7;
                return Promise.resolve(/* import() */).then(__webpack_require__.t.bind(__webpack_require__, 14934, 23)).then(function (cloudinary) {
                  return videoPlayer = cloudinary;
                });

              case 7:
                return _context.abrupt("return", {
                  videoPlayer: videoPlayer,
                  transformation: transformation
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create() {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "buildPlayerConfig",
    value: function buildPlayerConfig() {
      var _this$video, _this$video$keyframe, _this$video$keyframe$, _this$video$keyframe$2, _this$video$keyframe$3, _this$video$keyframe$4;

      var config = {
        muted: this.video.muted,
        loop: this.video.loop,
        fontFace: 'inherit',
        fluid: true,
        preload: this.video.preload ? true : false,
        controls: this.video.controls,
        autoplayMode: this.video.autoplay,
        playsinline: this.video.playsInline
      };

      if ((_this$video = this.video) == null ? void 0 : (_this$video$keyframe = _this$video.keyframe) == null ? void 0 : (_this$video$keyframe$ = _this$video$keyframe.fields) == null ? void 0 : (_this$video$keyframe$2 = _this$video$keyframe$.asset) == null ? void 0 : (_this$video$keyframe$3 = _this$video$keyframe$2.fields) == null ? void 0 : (_this$video$keyframe$4 = _this$video$keyframe$3.file) == null ? void 0 : _this$video$keyframe$4.url) {
        var _this$video2, _this$video2$keyframe, _this$video2$keyframe2, _this$video2$keyframe3, _this$video2$keyframe4, _this$video2$keyframe5;

        config['posterOptions'] = {
          publicId: (_this$video2 = this.video) == null ? void 0 : (_this$video2$keyframe = _this$video2.keyframe) == null ? void 0 : (_this$video2$keyframe2 = _this$video2$keyframe.fields) == null ? void 0 : (_this$video2$keyframe3 = _this$video2$keyframe2.asset) == null ? void 0 : (_this$video2$keyframe4 = _this$video2$keyframe3.fields) == null ? void 0 : (_this$video2$keyframe5 = _this$video2$keyframe4.file) == null ? void 0 : _this$video2$keyframe5.url
        };
      }

      return config;
    }
  }]);

  return VideoPlayerFactory;
}();

/* harmony default export */ __webpack_exports__["Z"] = (VideoPlayerFactory);

/***/ }),

/***/ 65509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12419);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7980);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33227);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88361);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_inherits_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85971);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_inherits_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_inherits_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52715);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91193);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23123);
/* harmony import */ var core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_split_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(24812);
/* harmony import */ var core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_bind_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _adapters_helpers_ConstantsGA__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75176);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67294);
/* harmony import */ var _adapters_helpers_VideoPlayerFactory__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(48853);
/* harmony import */ var _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(24036);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(85893);













function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }








var VideoPlayer = /*#__PURE__*/function (_Component) {
  _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_inherits_js__WEBPACK_IMPORTED_MODULE_5___default()(VideoPlayer, _Component);

  var _super = _createSuper(VideoPlayer);

  function VideoPlayer(props) {
    var _this;

    _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_classCallCheck_js__WEBPACK_IMPORTED_MODULE_3___default()(this, VideoPlayer);

    _this = _super.call(this, props);
    _this.videoRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_13__.createRef();
    _this.videoPlayer = null;
    _this.video = props.video;
    _this.state = {
      video: null
    };
    return _this;
  }

  _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_createClass_js__WEBPACK_IMPORTED_MODULE_4___default()(VideoPlayer, [{
    key: "getVideo",
    value: function getVideo() {
      return this.video;
    }
  }, {
    key: "getVideoRef",
    value: function getVideoRef() {
      var _this$videoRef;

      return (_this$videoRef = this.videoRef) == null ? void 0 : _this$videoRef.current;
    }
  }, {
    key: "getVideoCustomID",
    value: function getVideoCustomID(string) {
      var _this$video;

      var videoCustomId = (_this$video = this.video) == null ? void 0 : _this$video.assetId;

      if (videoCustomId) {
        videoCustomId = videoCustomId.split('/');
        return string + '-' + videoCustomId[videoCustomId.length - 1];
      }
    }
  }, {
    key: "getVideoPlayerRef",
    value: function getVideoPlayerRef() {
      return this.videoPlayer;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.videoIsDefined()) {
        var videoPlayerFactory = new _adapters_helpers_VideoPlayerFactory__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z(this.videoRef, this.video);
        this.createVideoPlayer(videoPlayerFactory);
      }
    } // eslint-disable-next-line no-unused-vars

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (this.state && this.state.video && this.video !== this.props.video) {
        var _this$props$video, _this$props$video$sub, _this$props$video2, _this$props$video2$ca, _this$props$video2$ca2, _this$props$video3, _this$props$video3$ca, _this$props$video3$ca2, _this$props$video4, _this$props$video4$ca, _this$props$video4$ca2, _this$props$video5, _this$props$video5$ca, _this$props$video5$ca2, _this$video$asset, _this$video$asset$fie, _this$video$asset$fie2, _this$props$video6;

        var subTitles = (_this$props$video = this.props.video) == null ? void 0 : (_this$props$video$sub = _this$props$video.subTitles) == null ? void 0 : _this$props$video$sub.map(function (subtitle) {
          var _subtitle$fields, _subtitle$fields2, _subtitle$fields3;

          return {
            label: subtitle == null ? void 0 : (_subtitle$fields = subtitle.fields) == null ? void 0 : _subtitle$fields.label,
            language: subtitle == null ? void 0 : (_subtitle$fields2 = subtitle.fields) == null ? void 0 : _subtitle$fields2.language,
            url: subtitle == null ? void 0 : (_subtitle$fields3 = subtitle.fields) == null ? void 0 : _subtitle$fields3.url
          };
        });
        var textTracks = {
          captions: {
            label: (_this$props$video2 = this.props.video) == null ? void 0 : (_this$props$video2$ca = _this$props$video2.captions) == null ? void 0 : (_this$props$video2$ca2 = _this$props$video2$ca.fields) == null ? void 0 : _this$props$video2$ca2.label,
            "default": (_this$props$video3 = this.props.video) == null ? void 0 : (_this$props$video3$ca = _this$props$video3.captions) == null ? void 0 : (_this$props$video3$ca2 = _this$props$video3$ca.fields) == null ? void 0 : _this$props$video3$ca2["default"],
            language: (_this$props$video4 = this.props.video) == null ? void 0 : (_this$props$video4$ca = _this$props$video4.captions) == null ? void 0 : (_this$props$video4$ca2 = _this$props$video4$ca.fields) == null ? void 0 : _this$props$video4$ca2.language,
            url: (_this$props$video5 = this.props.video) == null ? void 0 : (_this$props$video5$ca = _this$props$video5.captions) == null ? void 0 : (_this$props$video5$ca2 = _this$props$video5$ca.fields) == null ? void 0 : _this$props$video5$ca2.url
          },
          subtitles: subTitles && _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2___default()(subTitles)
        };
        this.state.video.source((_this$video$asset = this.video.asset) == null ? void 0 : (_this$video$asset$fie = _this$video$asset.fields) == null ? void 0 : (_this$video$asset$fie2 = _this$video$asset$fie.file) == null ? void 0 : _this$video$asset$fie2.url, {
          textTracks: subTitles && ((_this$props$video6 = this.props.video) == null ? void 0 : _this$props$video6.captions) && textTracks
        });

        if (this.props.video.videoSettings) {
          var videoSettings = this.props.video.videoSettings.fields;
          var transformations = {
            video_codec: (videoSettings == null ? void 0 : videoSettings.videoFormat) || 'auto',
            quality: (videoSettings == null ? void 0 : videoSettings.quality) || 'auto',
            width: (videoSettings == null ? void 0 : videoSettings.width) || null,
            height: (videoSettings == null ? void 0 : videoSettings.height) || null,
            crop: (videoSettings == null ? void 0 : videoSettings.crop) || 'limit'
          };
          this.state.video.transformation(transformations);
        }
      }
    }
  }, {
    key: "createVideoPlayer",
    value: function createVideoPlayer(videoPlayerFactory) {
      var _this$props$video7,
          _this$props$video7$su,
          _this$props$video8,
          _this$props$video8$ca,
          _this$props$video8$ca2,
          _this$props$video9,
          _this$props$video9$ca,
          _this$props$video9$ca2,
          _this$props$video10,
          _this$props$video10$c,
          _this$props$video10$c2,
          _this$props$video11,
          _this$props$video11$c,
          _this$props$video11$c2,
          _this$props$video12,
          _this2 = this;

      var subTitles = (_this$props$video7 = this.props.video) == null ? void 0 : (_this$props$video7$su = _this$props$video7.subTitles) == null ? void 0 : _this$props$video7$su.map(function (subtitle) {
        var _subtitle$fields4, _subtitle$fields5, _subtitle$fields6;

        return {
          label: subtitle == null ? void 0 : (_subtitle$fields4 = subtitle.fields) == null ? void 0 : _subtitle$fields4.label,
          language: subtitle == null ? void 0 : (_subtitle$fields5 = subtitle.fields) == null ? void 0 : _subtitle$fields5.language,
          url: subtitle == null ? void 0 : (_subtitle$fields6 = subtitle.fields) == null ? void 0 : _subtitle$fields6.url
        };
      });
      var textTracks = {
        captions: {
          label: (_this$props$video8 = this.props.video) == null ? void 0 : (_this$props$video8$ca = _this$props$video8.captions) == null ? void 0 : (_this$props$video8$ca2 = _this$props$video8$ca.fields) == null ? void 0 : _this$props$video8$ca2.label,
          "default": (_this$props$video9 = this.props.video) == null ? void 0 : (_this$props$video9$ca = _this$props$video9.captions) == null ? void 0 : (_this$props$video9$ca2 = _this$props$video9$ca.fields) == null ? void 0 : _this$props$video9$ca2["default"],
          language: (_this$props$video10 = this.props.video) == null ? void 0 : (_this$props$video10$c = _this$props$video10.captions) == null ? void 0 : (_this$props$video10$c2 = _this$props$video10$c.fields) == null ? void 0 : _this$props$video10$c2.language,
          url: (_this$props$video11 = this.props.video) == null ? void 0 : (_this$props$video11$c = _this$props$video11.captions) == null ? void 0 : (_this$props$video11$c2 = _this$props$video11$c.fields) == null ? void 0 : _this$props$video11$c2.url
        },
        subtitles: subTitles && _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_2___default()(subTitles)
      };
      textTracks = subTitles && ((_this$props$video12 = this.props.video) == null ? void 0 : _this$props$video12.captions) && textTracks;
      var source = textTracks ? {
        sourceTypes: ['webm', 'mp4', 'hls', 'ogg'],
        textTracks: textTracks
      } : {
        sourceTypes: ['webm', 'mp4', 'hls', 'ogg']
      };
      videoPlayerFactory.create().then(function (_ref) {
        var _this2$video$asset, _this2$video$asset$fi, _this2$video$asset$fi2;

        var videoPlayer = _ref.videoPlayer,
            transformation = _ref.transformation;
        var video = videoPlayer.Cloudinary["new"]({
          secure: true
        }).videoPlayer(_this2.videoRef.current, {
          muted: _this2.video.muted,
          loop: _this2.video.loop,
          fontFace: 'inherit',
          fluid: true,
          preload: _this2.video.preload ? true : false,
          controls: _this2.video.controls,
          autoplayMode: _this2.video.autoplay,
          playsinline: _this2.video.playsInline
        }).transformation(transformation).source((_this2$video$asset = _this2.video.asset) == null ? void 0 : (_this2$video$asset$fi = _this2$video$asset.fields) == null ? void 0 : (_this2$video$asset$fi2 = _this2$video$asset$fi.file) == null ? void 0 : _this2$video$asset$fi2.url, source);

        _this2.setState({
          video: video
        });

        _this2.videoPlayer = video;

        _this2.videoPlayer.on('canplay', _this2.onVideoLoaded.bind(_this2));

        _this2.videoPlayer.on('play', _this2.onVideoPlay.bind(_this2));

        _this2.videoPlayer.on('pause', _this2.onVideoPause.bind(_this2));

        _this2.videoPlayer.on('mute', _this2.onVideoMuted.bind(_this2));

        _this2.videoPlayer.on('unmute', _this2.onVideoUnMuted.bind(_this2));

        _this2.videoPlayer.on('fullscreenchange', _this2.onVideoFullScreen.bind(_this2));
      })["catch"](function () {});
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.videoPlayer) {
        this.videoPlayer.off('canplay', this.onVideoLoaded.bind(this));
        this.videoPlayer.off('play', this.onVideoPlay.bind(this));
        this.videoPlayer.off('pause', this.onVideoPause.bind(this));
        this.videoPlayer.off('mute', this.onVideoMuted.bind(this));
        this.videoPlayer.off('unmute', this.onVideoUnMuted.bind(this));
        this.videoPlayer.off('fullscreenchange', this.onVideoFullScreen.bind(this));
      }
    }
  }, {
    key: "onVideoLoaded",
    value: function onVideoLoaded() {
      this.videoPlayer.off('canplay', this.onVideoLoaded.bind(this));
      this.setAnalyticsPlayPauseTags();
      this.setAnalyticsMuteUnmuteTags();
      this.setAnalyticsFullScreenTags();
      this.setAnalyticsCaptionsTags();
      this.setVideoDOMContent();
    }
  }, {
    key: "onVideoPause",
    value: function onVideoPause() {
      if (this.props.onVideoPlaying) {
        this.props.onVideoPlaying(false);
      }

      this.setAnalyticsPlayPauseTags();
    }
  }, {
    key: "onVideoPlay",
    value: function onVideoPlay() {
      if (this.props.onVideoPlaying) {
        this.props.onVideoPlaying(true);
      }

      this.setAnalyticsPlayPauseTags();
    }
  }, {
    key: "onVideoMuted",
    value: function onVideoMuted() {
      this.setAnalyticsMuteUnmuteTags();
    }
  }, {
    key: "onVideoUnMuted",
    value: function onVideoUnMuted() {
      this.setAnalyticsMuteUnmuteTags();
    }
  }, {
    key: "onVideoFullScreen",
    value: function onVideoFullScreen() {
      this.setAnalyticsFullScreenTags();
    }
  }, {
    key: "setAnalyticsPlayPauseTags",
    value: function setAnalyticsPlayPauseTags() {
      if (this.videoRef.current.parentNode) {
        var isVideoPaused = this.videoRef.current.parentNode.classList.contains('vjs-paused');
        var playPauseButton = this.videoRef.current.parentNode.querySelector('button.vjs-play-control');
        this.setElementAnalytics(playPauseButton, 'event-video-play', _adapters_helpers_ConstantsGA__WEBPACK_IMPORTED_MODULE_12__/* .AnalyticsConstants.videoPlayText */ .k.videoPlayText, _adapters_helpers_ConstantsGA__WEBPACK_IMPORTED_MODULE_12__/* .AnalyticsConstants.videoPauseText */ .k.videoPauseText, !isVideoPaused);
        var bigPlayButton = this.videoRef.current.parentNode.querySelector('button.vjs-big-play-button');
        this.setElementAnalytics(bigPlayButton, 'event-video-play', _adapters_helpers_ConstantsGA__WEBPACK_IMPORTED_MODULE_12__/* .AnalyticsConstants.videoPlayText */ .k.videoPlayText, _adapters_helpers_ConstantsGA__WEBPACK_IMPORTED_MODULE_12__/* .AnalyticsConstants.videoPauseText */ .k.videoPauseText, !isVideoPaused);
      }
    }
  }, {
    key: "setAnalyticsMuteUnmuteTags",
    value: function setAnalyticsMuteUnmuteTags() {
      if (this.videoRef.current.parentNode) {
        var isVideoMuted = this.videoRef.current.getAttribute('muted');
        var muteUnmuteButton = this.videoRef.current.parentNode.querySelector('button.vjs-mute-control');
        this.setElementAnalytics(muteUnmuteButton, 'event-button-click', _adapters_helpers_ConstantsGA__WEBPACK_IMPORTED_MODULE_12__/* .AnalyticsConstants.videoUnmuteText */ .k.videoUnmuteText, _adapters_helpers_ConstantsGA__WEBPACK_IMPORTED_MODULE_12__/* .AnalyticsConstants.videoMuteText */ .k.videoMuteText, !isVideoMuted);
      }
    }
  }, {
    key: "setAnalyticsFullScreenTags",
    value: function setAnalyticsFullScreenTags() {
      if (this.videoRef.current.parentNode) {
        var isVideoFullScreen = this.videoRef.current.parentNode.classList.contains('vjs-fullscreen');
        var fullscreenButton = this.videoRef.current.parentNode.querySelector('button.vjs-fullscreen-control');
        this.setElementAnalytics(fullscreenButton, 'event-button-click', _adapters_helpers_ConstantsGA__WEBPACK_IMPORTED_MODULE_12__/* .AnalyticsConstants.videoFullscreenOffText */ .k.videoFullscreenOffText, _adapters_helpers_ConstantsGA__WEBPACK_IMPORTED_MODULE_12__/* .AnalyticsConstants.videoFullscreenOnText */ .k.videoFullscreenOnText, !isVideoFullScreen);
      }
    }
  }, {
    key: "setAnalyticsCaptionsTags",
    value: function setAnalyticsCaptionsTags() {
      if (this.videoRef.current.parentNode) {
        var isCaptionsVisible = this.videoRef.current.parentNode.querySelector('div.vjs-text-track-cue');
        var captionsButton = this.videoRef.current.parentNode.querySelector('button.vjs-subs-caps-button');
        this.setElementAnalytics(captionsButton, 'event-button-click', _adapters_helpers_ConstantsGA__WEBPACK_IMPORTED_MODULE_12__/* .AnalyticsConstants.videoCloseCaptionsOffText */ .k.videoCloseCaptionsOffText, _adapters_helpers_ConstantsGA__WEBPACK_IMPORTED_MODULE_12__/* .AnalyticsConstants.videoCloseCaptionsOnText */ .k.videoCloseCaptionsOnText, !isCaptionsVisible);
      }
    }
  }, {
    key: "setElementAnalytics",
    value: function setElementAnalytics(element, className, dataActionDetail) {
      var dataActionDetailAlternative = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var isAlternative = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      if (element) {
        if (!element.classList.contains(className)) {
          element.classList.add(className);
        }

        if (!isAlternative) {
          element.setAttribute('data-action-detail', dataActionDetail);
        } else {
          element.setAttribute('data-action-detail', dataActionDetailAlternative);
        }
      }
    }
  }, {
    key: "setVideoDOMContent",
    value: function setVideoDOMContent() {
      if (this.videoRef.current.parentNode) {
        var overlayItem = this.videoRef.current.parentNode.querySelector('div.vjs-recommendations-overlay-item-info');
        var cloudinaryButton = this.videoRef.current.parentNode.querySelector('a.vjs-cloudinary-button');

        if (cloudinaryButton) {
          cloudinaryButton.innerHTML = 'Cloudinary Logo';
        }

        if (overlayItem) {
          var h2Ele = overlayItem.getElementsByTagName('h2');
          var h3Ele = overlayItem.getElementsByTagName('h3');
          h2Ele && h2Ele[0] ? h2Ele[0].innerHTML = _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_15__/* .VideoPlayerConstants.videoRecommendations */ .K1.videoRecommendations : '';
          h3Ele && h3Ele[0] ? h3Ele[0].innerHTML = _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_15__/* .VideoPlayerConstants.videoRecommendations */ .K1.videoRecommendations : '';
        }
      }
    }
  }, {
    key: "videoIsDefined",
    value: function videoIsDefined() {
      var _this$video$asset2, _this$video$asset2$fi, _this$video$asset2$fi2;

      return this.video && ((_this$video$asset2 = this.video.asset) == null ? void 0 : (_this$video$asset2$fi = _this$video$asset2.fields) == null ? void 0 : (_this$video$asset2$fi2 = _this$video$asset2$fi.file) == null ? void 0 : _this$video$asset2$fi2.url);
    }
  }, {
    key: "renderTranscript",
    value: function renderTranscript() {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
        className: "video-player-transcript visuallyhidden",
        children: this.video.transcript
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$video13, _this$props$video13$c, _this$props$video14, _subtitlesVideo$, _this$props$video15, _this$video$asset3, _this$video$asset3$fi, _this$video$asset3$fi2;

      var captionsTrack = (_this$props$video13 = this.props.video) == null ? void 0 : (_this$props$video13$c = _this$props$video13.captions) == null ? void 0 : _this$props$video13$c.fields;
      var subtitlesVideo = (_this$props$video14 = this.props.video) == null ? void 0 : _this$props$video14.subTitles;
      var subTitleTrack = subtitlesVideo ? (_subtitlesVideo$ = subtitlesVideo[0]) == null ? void 0 : _subtitlesVideo$.fields : null;
      var ariaLabel = (_this$props$video15 = this.props.video) == null ? void 0 : _this$props$video15.ariaLabel;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("div", {
        className: "ob-video-player",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("video", {
          muted: true,
          playsInline: true,
          id: this.getVideoCustomID(_adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_15__/* .VideoPlayerConstants.id */ .K1.id),
          ref: this.videoRef,
          "aria-label": ariaLabel,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("source", {
            src: 'https:' + ((_this$video$asset3 = this.video.asset) == null ? void 0 : (_this$video$asset3$fi = _this$video$asset3.fields) == null ? void 0 : (_this$video$asset3$fi2 = _this$video$asset3$fi.file) == null ? void 0 : _this$video$asset3$fi2.url),
            type: "video/mp4"
          }), captionsTrack && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("track", {
            label: captionsTrack == null ? void 0 : captionsTrack.label,
            kind: "captions",
            srcLang: captionsTrack == null ? void 0 : captionsTrack.language,
            src: captionsTrack == null ? void 0 : captionsTrack.url,
            "default": captionsTrack == null ? void 0 : captionsTrack["default"]
          }), subTitleTrack && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("track", {
            label: subTitleTrack == null ? void 0 : subTitleTrack.label,
            kind: "subtitles",
            srcLang: subTitleTrack == null ? void 0 : subTitleTrack.language,
            src: subTitleTrack == null ? void 0 : subTitleTrack.url,
            "default": subTitleTrack == null ? void 0 : subTitleTrack["default"]
          })]
        }), this.renderTranscript()]
      });
    }
  }]);

  return VideoPlayer;
}(react__WEBPACK_IMPORTED_MODULE_13__.Component);

/* harmony default export */ __webpack_exports__["Z"] = (VideoPlayer);

/***/ })

}]);